/*
 * mocks/api/auth.ts
 * Anvilo, Inc.
 *
 * This file contains authorization API mocks
 *
 * Created by Artem Yefimenko on 10/08/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import { mock } from "../axios";

const API_URL = "https://testing-webapp-api.talkroute.com/api/";

const REQUEST_TOKEN_URL = "oauth-login";
const GET_PERMISSIONS = "v1/account/user/permissions";

mock.onAny(`${API_URL}${REQUEST_TOKEN_URL}`).reply((request) => {
  return [
    200,
    {
      company_name: "Test company",
      first_name: "First name",
      last_name: "Last name",
      token:
        "Mzer3WlK6Pfxy09W4FRThi3CdqgaR9tSqYDY1tTGE4HD3tFWDKyqJahOALPJjr4KrU8k85WpulX5oTuPpJiZIpXkS0zuYauIj2+cKYM7keXdwmrG",
      webrtc_password: "baf19f05402cfd9cec5a89e3b27f856727a32b54",
      webrtc_username: "f887eb9986433a9287846285dbdd05f97fc6d775",
    },
  ];
});

mock.onGet(`${API_URL}${GET_PERMISSIONS}`).reply((request) => {
  return [
    200,
    {
      user_permissions: {
        item_account_billing: "edit",
        item_account_user: "edit",
        item_audio_file: "edit",
        item_blocked_number: "edit",
        item_call_menu: "edit",
        item_call_recording: "edit",
        item_did: "edit",
        item_extension: "edit",
        item_forwarding_device: "edit",
        item_forwarding_schedule: "edit",
        item_hours_of_operation: "edit",
        item_text_messaging: "edit",
        item_vmbox: "edit",
      },
      user_role: "account_admin",
    },
  ];
});
